export default "__VITE_ASSET__CWlZ8K0y__"